module.exports = "<p>\n  alert-page works!\n</p>\n"